import { render } from "./PlayHeader.vue?vue&type=template&id=fa050b7a"
import script from "./PlayHeader.vue?vue&type=script&lang=js"
export * from "./PlayHeader.vue?vue&type=script&lang=js"

import exportComponent from "C:\\BiggerInside\\Protocol223-Portal\\portal\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__